import { Dispatch } from 'redux';
import {
  httpError,
  fetchGet,
  json,
  fetchPost,
  showWarnNotification,
  showSuccessNotification,
} from 'common';
import {
  SEARCH_DETAILS_ADD,
  SEARCH_DETAILS_CLEAR,
  SEARCH_DETAILS_LOADING,
} from './SearchDetails.types';
import {
  Lien,
  RecordedDocument,
  EnvironmentalControlBoardJudgment,
  ParkingViolationJudgment,
  TransitAdjudicationBureauJudgment,
} from 'pages/Search/models';

export function searchDetailsAdd(
  item:
    | null
    | Lien
    | RecordedDocument
    | EnvironmentalControlBoardJudgment
    | ParkingViolationJudgment
    | TransitAdjudicationBureauJudgment,
) {
  return {
    type: SEARCH_DETAILS_ADD,
    payload: item,
  };
}

export function searchDetailsClear() {
  return {
    type: SEARCH_DETAILS_CLEAR,
  };
}

export function searchDetailsLoading(loading: boolean) {
  return {
    type: SEARCH_DETAILS_LOADING,
    payload: loading,
  };
}

export function fetchDetailsAsync(
  type: string,
  boro: number,
  documentId: string,
  bearerToken: string,
) {
  const apiUri: string = process.env.REACT_APP_API_URI as string;

  return (dispatch: Dispatch) => {
    dispatch(searchDetailsLoading(true));
    fetchGet(
      `${apiUri}/RecordedDocuments/${boro}/${type}/${documentId}`,
      bearerToken,
    )
      .then(httpError(dispatch))
      .then(json)
      .then((response) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        return response;
      })
      .then((item: RecordedDocument) => {
        dispatch(searchDetailsLoading(false));
        return dispatch(searchDetailsAdd(item));
      })
      .catch((error) => {
        dispatch(searchDetailsLoading(false));
        showWarnNotification(`Fetch details`, error.message);
      });
  };
}

export function fetchExternalDetailsAsync(
  filesId: string[],
  bearerToken: string,
) {
  const apiUri: string = process.env.REACT_APP_API_URI as string;

  return (dispatch: Dispatch) => {
    dispatch(searchDetailsLoading(true));
    fetchPost(`${apiUri}/RecordedDocuments/getDocument`, filesId, bearerToken)
      .then(httpError(dispatch))
      .then(json)
      .then((response) => {
        if (response.errorMessage) throw Error(response.errorMessage);
        return response;
      })
      .then((res) => {
        dispatch(searchDetailsLoading(false));
        showSuccessNotification(`Fetch details`, `New tab should open`);
        window.open(
          `http://viewer.brsonline.com/?doc=${res.guid}&p=1&fmt=H950W750C10`,
          '_blank',
        );
      })
      .catch((error) => {
        dispatch(searchDetailsLoading(false));
        showWarnNotification(`Fetch details`, error.message);
      });
  };
}
